module.exports = {"id":"161956","name":"Borja Valero","rating":"83","photo":"./data/images/photos/1/161956.png","club":{"name":"Inter","logo":"./data/images/clubs/Inter.png"},"positions":["MOC","MC","MDC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BorjaValero0.json
// module id = 624
// module chunks = 0